import {
	AwsSettings, HttpSettings, ProtocolSettings, ProtocolSettingsTypes, PrtgSettings, SnmpSettings,
	SshSettings, TelnetSettings, VimSettings, WindowsSettings, PingSettings
} from ".";
import { StringUtils } from "DiscoveryEngine.TS/Utils";


export class ProtocolSettingsUtils {

	public static ObfuscatePasswords(ps: ProtocolSettings): void {
		switch (ps.SettingsType) {
			case ProtocolSettingsTypes.Ping:
				{
					let settings = (ps as PingSettings);
				}
				break;
			case ProtocolSettingsTypes.Snmp:
				{
					let settings = (ps as SnmpSettings);
					settings.WriteCommunity = StringUtils.ObfuscateString2(settings.WriteCommunity);
					settings.AuthPassword = StringUtils.ObfuscateString2(settings.AuthPassword);
					settings.EncryptPassword = StringUtils.ObfuscateString2(settings.EncryptPassword);
				}
				break;
			case ProtocolSettingsTypes.Windows:
				{
					let settings = (ps as WindowsSettings);
					settings.Password = StringUtils.ObfuscateString2(settings.Password);
				}
				break;
			case ProtocolSettingsTypes.Ssh:
				{
					let settings = (ps as SshSettings);
					settings.Password = StringUtils.ObfuscateString2(settings.Password);
					settings.EnablePassword = StringUtils.ObfuscateString2(settings.EnablePassword);
				}
				break;
			case ProtocolSettingsTypes.Telnet:
				{
					let settings = ps as TelnetSettings;
					settings.Password = StringUtils.ObfuscateString2(settings.Password);
					settings.EnablePassword = StringUtils.ObfuscateString2(settings.EnablePassword);
				}
				break;
			case ProtocolSettingsTypes.Vim:
				{
					let settings = (ps as VimSettings);
					settings.Password = StringUtils.ObfuscateString2(settings.Password);
				}
				break;
			case ProtocolSettingsTypes.Prtg:
				{
					var settings = (ps as PrtgSettings);
					settings.Passhash = StringUtils.ObfuscateString2(settings.Passhash);
					settings.ServiceApiKey = StringUtils.ObfuscateString2(settings.ServiceApiKey);
				}
				break;
			case ProtocolSettingsTypes.AWS:
				{
					let settings = (ps as AwsSettings);
					settings.SecretKey = StringUtils.ObfuscateString2(settings.SecretKey);
				}
				break;
			case ProtocolSettingsTypes.HTTP:
				{
					let settings = (ps as HttpSettings);
					settings.Password = StringUtils.ObfuscateString2(settings.Password);
					settings.EnablePassword = StringUtils.ObfuscateString2(settings.EnablePassword);
				}
				break;
			default:
				console.assert(false);
				throw new Error("Invalid protocol settings type: " + ps.SettingsType);
		}
	}

	public static ClarifyPasswords(ps: ProtocolSettings): void {
		switch (ps.SettingsType) {
			case ProtocolSettingsTypes.Ping:
				{
					let settings = (ps as PingSettings);
				}
				break;
			case ProtocolSettingsTypes.Snmp:
				{
					let settings = (ps as SnmpSettings);
					settings.WriteCommunity = StringUtils.ClarifyString2(settings.WriteCommunity);
					settings.AuthPassword = StringUtils.ClarifyString2(settings.AuthPassword);
					settings.EncryptPassword = StringUtils.ClarifyString2(settings.EncryptPassword);
				}
				break;
			case ProtocolSettingsTypes.Windows:
				{
					let settings = (ps as WindowsSettings);
					settings.Password = StringUtils.ClarifyString2(settings.Password);
				}
				break;
			case ProtocolSettingsTypes.Ssh:
				{
					let settings = (ps as SshSettings);
					settings.Password = StringUtils.ClarifyString2(settings.Password);
					settings.EnablePassword = StringUtils.ClarifyString2(settings.EnablePassword);
				}
				break;
			case ProtocolSettingsTypes.Telnet:
				{
					let settings = (ps as TelnetSettings);
					settings.Password = StringUtils.ClarifyString2(settings.Password);
					settings.EnablePassword = StringUtils.ClarifyString2(settings.EnablePassword);
				}
				break;
			case ProtocolSettingsTypes.Vim:
				{
					let settings = (ps as VimSettings);
					settings.Password = StringUtils.ClarifyString2(settings.Password);
				}
				break;
			case ProtocolSettingsTypes.Prtg:
				{
					let settings = (ps as PrtgSettings);
					settings.Passhash = StringUtils.ClarifyString2(settings.Passhash);
					settings.ServiceApiKey = StringUtils.ClarifyString2(settings.ServiceApiKey);
				}
				break;
			case ProtocolSettingsTypes.AWS:
				{
					let settings = (ps as AwsSettings);
					settings.SecretKey = StringUtils.ClarifyString2(settings.SecretKey);
				}
				break;
			case ProtocolSettingsTypes.HTTP:
				{
					let settings = (ps as HttpSettings);
					settings.Password = StringUtils.ClarifyString2(settings.Password);
					settings.EnablePassword = StringUtils.ClarifyString2(settings.EnablePassword);
				}
				break;
			default:
				console.assert(false);
				throw new Error("Invalid protocol settings type: " + ps.SettingsType);
		}
	}

}
